import React, { type FC, useEffect } from "react";
import { trackLoaded, withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { useTrackElement, useTracking } from "@edreamsodigeo/frontend-core";

import type { SuccessProps } from "./contract";
import SuccessBody from "./SuccessBody";

const { SUCCESS } = screenNames;

const getTrackingId = (previousScreen: string): string =>
  `${SUCCESS}:${previousScreen}`;

const Success: FC<SuccessProps> = ({ trackingPrefix }) => {
  const { state } = useScreenState();
  const { trackEvent } = useTracking();
  const { previousScreen } = state;
  const trackingRef = useTrackElement(
    ["display"],
    withPrefix(getTrackingId(previousScreen), trackingPrefix),
  );
  const gaTrackingPrefix = state.gaTrackingPrefix || trackingPrefix;
  useEffect(() => {
    trackLoaded({
      trackEvent,
      screen: SUCCESS,
      prefix: gaTrackingPrefix,
    });
  }, [trackEvent, gaTrackingPrefix]);
  return <SuccessBody ref={trackingRef} />;
};
export default Success;
